import setting from '$modules/setting/routes'

export default [
  {
    path: 'contract',
    meta: {
      title: 'Contracts',
      auth: ['Admin', 'Super Admin'],
      hidden: false,
      icon: 'archive'
    },
    component: () => import('./pages/index'),
    redirect: 'contract/list',
    children: [
      {
        path: 'list',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'List',
          resource: 'contract',
          icon: 'playlist_add_check',
          hidden: false
        },
        component: () => import('./pages/list')
      },
      {
        path: 'edit/:id',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Edit',
          resource: 'contract',
          icon: 'mode_edit',
          hidden: true
        },
        component: () => import('./pages/edit')
      },
      {
        path: 'add',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Add',
          resource: 'contract',
          icon: 'add_circle_outline',
          hidden: false
        },
        component: () => import('./pages/add')
      }
    ].concat(setting)
  }
]
